module.exports = __webpack_public_path__ + "static/media/game_consoles_icon.c441839f.png";